/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Rule_TieInputs */

const en_directory_vibebids_rule_tie = /** @type {(inputs: Directory_Vibebids_Rule_TieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier bids win ties.`)
};

const zh_directory_vibebids_rule_tie = /** @type {(inputs: Directory_Vibebids_Rule_TieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同价时，较早提交的出价优先。`)
};

/**
* | output |
* | --- |
* | "Earlier bids win ties." |
*
* @param {Directory_Vibebids_Rule_TieInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_rule_tie = /** @type {((inputs?: Directory_Vibebids_Rule_TieInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Rule_TieInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_rule_tie(inputs)
	return zh_directory_vibebids_rule_tie(inputs)
});
export { directory_vibebids_rule_tie as "directory.vibebids.rule_tie" }